import { Tabs } from '@mantine/core';
import { WalletTabTable } from './WalletTabTable';
import { WalletVerify } from './WalletVerify';
export const Wallet: React.FC = () => {
  return <Tabs.Panel value="wallet">
      <WalletTabTable />
      <WalletVerify />
    </Tabs.Panel>;
};